module.exports = __webpack_public_path__ + "img/orders.21a53149.svg";